// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b97c4fa5","498":"cdad42de","513":"12281a18","787":"69906fe7"}[chunkId] + ".chunk.js";
};